import {inject} from '@angular/core';
import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {UserProfileService} from '../services/api/user-profile.service';

// Returns true to allow user or UrlTree to redirect to root route. Without the UrlTree (false), user gets stuck in loading screen
export const ClientOrCustomerUserGuard: CanActivateFn = (): boolean | UrlTree => {
  const userProfileService = inject(UserProfileService);
  const router = inject(Router);
  const loggedInUser = userProfileService.getLoggedInUser();
  return loggedInUser.isCustomerUserOrPlatformAdmin() || loggedInUser.isClientUser() || router.createUrlTree(['/']);
}
